import React, { useEffect, useState } from 'react';
import { EditableOutlined } from '@duxton-web/icons';
import { Button, Select, Spin, Tag, theme } from '@duxton-web/ui';

import { GrabAreaItem } from './const';
import GrabAreaModal from './GrabAreaModal';
import { useBatchSearchGrabAreas } from './hooks';

interface GrabAreaSelectorProps {
  value: string[];
  onChange: (values: string[]) => void;
}

export const GrabAreaSelector: React.FC<GrabAreaSelectorProps> = ({
  value,
  onChange,
}) => {
  const { data: batchSeachGrabAreasResult, isLoading } =
    useBatchSearchGrabAreas(value.map((v) => parseInt(v)));
  const [openGrabAreaModal, setOpenGrabAreaModal] = useState(false);
  const [selectedValues, setSelectedValues] = useState<GrabAreaItem[]>([]);

  useEffect(() => {
    if (!batchSeachGrabAreasResult) {
      return;
    }
    const detailedGrabAreas = value.map((areaID) => {
      const area = batchSeachGrabAreasResult.grabAreasInfo?.find(
        (area) => area.areaID === parseInt(areaID),
      );
      if (!area) {
        return {
          areaId: parseInt(areaID),
          areaName: '',
          countryID: -1,
          layer: '',
        };
      }
      return {
        areaId: area.areaID,
        areaName: area.areaName,
        countryID: area.countryID,
        layer: area.layer,
      };
    });
    setSelectedValues(detailedGrabAreas);
  }, [batchSeachGrabAreasResult]);

  return (
    <>
      {!value.length ? (
        <Button
          type="secondary"
          onClick={() => {
            setOpenGrabAreaModal(true);
          }}
          style={{
            fontSize: theme.getDesignToken().fontSize,
          }}
        >
          Add one or multiple areas
        </Button>
      ) : (
        <div
          style={{ display: 'flex', gap: '10px' }}
          className="grabAreaSelectorWrapper"
        >
          <Select
            disabled={isLoading}
            mode="multiple"
            style={{
              width: '100%',
            }}
            value={selectedValues.map(
              (item) => `${item.areaName} (${item.areaId})`,
            )}
            tagRender={(props) => (
              <Tag {...props} closable={false}>
                {props.label}
              </Tag>
            )}
            suffixIcon={
              isLoading ? (
                <Spin size="small" />
              ) : (
                <EditableOutlined
                  style={{
                    color: '#3d3d3d',
                    cursor: 'pointer',
                  }}
                />
              )
            }
            onClick={() => {
              setOpenGrabAreaModal(true);
            }}
            open={false}
            showSearch={false}
          />
        </div>
      )}
      {openGrabAreaModal && (
        <GrabAreaModal
          selectedValues={selectedValues}
          onChange={(values) => {
            setSelectedValues(values);
            if (values.length) {
              onChange(values.map((v) => v.areaId.toString()));
            } else {
              onChange([]);
            }
          }}
          onClose={() => {
            setOpenGrabAreaModal(false);
          }}
        />
      )}
    </>
  );
};
